import React, { memo } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Spinner } from 'evergreen-ui';

import { CrossIcon } from 'public/icons';

import styles from './Modal.module.scss';

const Modal = ({
  title, subtitle, children, isOpen, onOpen, onClose, onAfterClose, className, loading, iconBeforeTitle: Icon, shouldCloseOnOverlayClick, shouldCloseOnEsc,
}) => (
  <ReactModal
    isOpen={isOpen}
    shouldFocusAfterRender
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    shouldCloseOnEsc={shouldCloseOnEsc}
    onAfterOpen={onOpen}
    onAfterClose={onAfterClose}
    onRequestClose={onClose}
    closeTimeoutMS={300}
    className={cn(styles.modal, className)}
    appElement={document.getElementById('__next')}
    overlayClassName={cn({
      [styles.beforeClose]: !isOpen,
    }, styles.overlay)}
  >
    {title && (
      <div className={cn(styles.titleContainer, subtitle && styles.withSubtitle)}>
        <div>
          {Icon}
          <p className={styles.title}>{title}</p>
        </div>

        <CrossIcon className={styles.cross} onClick={onClose} />
      </div>
    )}

    {loading && (
      <div className={styles.spinnerContainer}>
        <Spinner className={styles.spinner} />
      </div>
    )}

    {!loading && (
      <>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

        {children}
      </>
    )}
  </ReactModal>
);

Modal.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object, PropTypes.node]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onAfterClose: PropTypes.func,
  className: PropTypes.string,
  loading: PropTypes.bool,
  iconBeforeTitle: PropTypes.node,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldCloseOnEsc: PropTypes.bool,
};

Modal.defaultProps = {
  title: null,
  subtitle: null,
  onOpen: null,
  onClose: null,
  onAfterClose: null,
  className: null,
  loading: false,
  iconBeforeTitle: null,
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
};

export default memo(Modal);
